/**
 * Complete ISO 639-2 (3-letter) to ISO 639-1 (2-letter) mapping.
 * Only includes languages that have a valid 2-letter code.
 * Source: https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 */
export const Iso6392To6391 = {
    // A
    aar: 'aa', // Afar
    abk: 'ab', // Abkhazian
    afr: 'af', // Afrikaans
    aka: 'ak', // Akan
    amh: 'am', // Amharic
    ara: 'ar', // Arabic
    arg: 'an', // Aragonese
    asm: 'as', // Assamese
    ava: 'av', // Avaric
    aym: 'ay', // Aymara
    aze: 'az', // Azerbaijani

    // B
    bak: 'ba', // Bashkir
    bam: 'bm', // Bambara
    bel: 'be', // Belarusian
    ben: 'bn', // Bengali
    bis: 'bi', // Bislama
    bod: 'bo', // Tibetan
    bos: 'bs', // Bosnian
    bre: 'br', // Breton
    bul: 'bg', // Bulgarian

    // C
    cat: 'ca', // Catalan
    ces: 'cs', // Czech
    cha: 'ch', // Chamorro
    che: 'ce', // Chechen
    chu: 'cu', // Church Slavic
    chv: 'cv', // Chuvash
    cor: 'kw', // Cornish
    cos: 'co', // Corsican
    cre: 'cr', // Cree
    cym: 'cy', // Welsh

    // D
    dan: 'da', // Danish
    deu: 'de', // German
    div: 'dv', // Dhivehi
    dzo: 'dz', // Dzongkha

    // E
    ell: 'el', // Greek (Modern)
    eng: 'en', // English
    epo: 'eo', // Esperanto
    est: 'et', // Estonian
    eus: 'eu', // Basque
    ewe: 'ee', // Ewe

    // F
    fao: 'fo', // Faroese
    fas: 'fa', // Persian
    fij: 'fj', // Fijian
    fin: 'fi', // Finnish
    fra: 'fr', // French
    fry: 'fy', // Western Frisian
    ful: 'ff', // Fulah

    // G
    gla: 'gd', // Scottish Gaelic
    gle: 'ga', // Irish
    glg: 'gl', // Galician
    glv: 'gv', // Manx
    grn: 'gn', // Guarani
    guj: 'gu', // Gujarati

    // H
    hat: 'ht', // Haitian Creole
    hau: 'ha', // Hausa
    heb: 'he', // Hebrew
    her: 'hz', // Herero
    hin: 'hi', // Hindi
    hmo: 'ho', // Hiri Motu
    hrv: 'hr', // Croatian
    hun: 'hu', // Hungarian
    hye: 'hy', // Armenian

    // I
    ibo: 'ig', // Igbo
    ind: 'id', // Indonesian
    ina: 'ia', // Interlingua
    ile: 'ie', // Interlingue
    iku: 'iu', // Inuktitut
    ipk: 'ik', // Inupiaq
    isl: 'is', // Icelandic
    ita: 'it', // Italian

    // J
    jav: 'jv', // Javanese
    jpn: 'ja', // Japanese

    // K
    kal: 'kl', // Kalaallisut
    kan: 'kn', // Kannada
    kas: 'ks', // Kashmiri
    kat: 'ka', // Georgian
    kau: 'kr', // Kanuri
    kaz: 'kk', // Kazakh
    khm: 'km', // Central Khmer
    kik: 'ki', // Kikuyu
    kin: 'rw', // Kinyarwanda
    kir: 'ky', // Kirghiz
    kom: 'kv', // Komi
    kon: 'kg', // Kongo
    kor: 'ko', // Korean
    kua: 'kj', // Kuanyama
    kur: 'ku', // Kurdish

    // L
    lao: 'lo', // Lao
    lat: 'la', // Latin
    lav: 'lv', // Latvian
    lim: 'li', // Limburgan
    lin: 'ln', // Lingala
    lit: 'lt', // Lithuanian
    ltz: 'lb', // Luxembourgish

    // M
    mlg: 'mg', // Malagasy
    mlt: 'mt', // Maltese
    mon: 'mn', // Mongolian
    mri: 'mi', // Maori
    msa: 'ms', // Malay

    // N
    nau: 'na', // Nauru
    nav: 'nv', // Navajo
    nbl: 'nr', // South Ndebele
    nde: 'nd', // North Ndebele
    ndo: 'ng', // Ndonga
    nep: 'ne', // Nepali
    nld: 'nl', // Dutch
    nno: 'nn', // Norwegian Nynorsk
    nob: 'nb', // Norwegian Bokmål
    nor: 'no', // Norwegian
    nya: 'ny', // Chichewa

    // O
    oci: 'oc', // Occitan
    oji: 'oj', // Ojibwa
    orm: 'om', // Oromo

    // P
    pan: 'pa', // Punjabi
    pli: 'pi', // Pali
    pol: 'pl', // Polish
    por: 'pt', // Portuguese
    pus: 'ps', // Pashto

    // Q
    que: 'qu', // Quechua

    // R
    roh: 'rm', // Romansh
    ron: 'ro', // Romanian
    run: 'rn', // Rundi
    rus: 'ru', // Russian

    // S
    sag: 'sg', // Sango
    san: 'sa', // Sanskrit
    sin: 'si', // Sinhala
    slk: 'sk', // Slovak
    slv: 'sl', // Slovenian
    sme: 'se', // Northern Sami
    smo: 'sm', // Samoan
    sna: 'sn', // Shona
    snd: 'sd', // Sindhi
    som: 'so', // Somali
    sot: 'st', // Southern Sotho
    spa: 'es', // Spanish
    sqi: 'sq', // Albanian
    srd: 'sc', // Sardinian
    srp: 'sr', // Serbian
    ssw: 'ss', // Swati
    sun: 'su', // Sundanese
    swa: 'sw', // Swahili
    swe: 'sv', // Swedish

    // T
    tah: 'ty', // Tahitian
    tam: 'ta', // Tamil
    tat: 'tt', // Tatar
    tel: 'te', // Telugu
    tgk: 'tg', // Tajik
    tgl: 'tl', // Tagalog
    tha: 'th', // Thai
    tir: 'ti', // Tigrinya
    ton: 'to', // Tonga
    tsn: 'tn', // Tswana
    tso: 'ts', // Tsonga
    tuk: 'tk', // Turkmen
    tur: 'tr', // Turkish
    twi: 'tw', // Twi

    // U
    uig: 'ug', // Uighur
    ukr: 'uk', // Ukrainian
    urd: 'ur', // Urdu
    uzb: 'uz', // Uzbek

    // V
    ven: 've', // Venda
    vie: 'vi', // Vietnamese
    vol: 'vo', // Volapük

    // W
    wln: 'wa', // Walloon
    wol: 'wo', // Wolof

    // X
    xho: 'xh', // Xhosa

    // Y
    yid: 'yi', // Yiddish
    yor: 'yo', // Yoruba

    // Z
    zha: 'za', // Zhuang
    zho: 'zh', // Chinese
    zul: 'zu', // Zulu
};

/**
 * Convert ISO 639-2 (3-letter) to ISO 639-1 (2-letter).
 * Falls back to original code if no mapping exists.
 */
// export const to6391 = (code:any) => Iso6392To6391[code.toLowerCase()] || code;
type Iso6392Code = keyof typeof Iso6392To6391;

export const to6391 = (code: string): string => {
    const lowerCode = code.toLowerCase();
    return lowerCode in Iso6392To6391
        ? Iso6392To6391[lowerCode as Iso6392Code]
        : code;
};